import axios from "axios";
import moment from "moment";
import { API, FLASK_API, JAVA_DASHBOARD_API } from "../../constants";
import { IProgressProps } from "../../types";
import { getDataRangeByWeekNo } from "../utils";

export const getTeacherOverViewStats = (
  session: number,
  district?: number,
  block?: number,
  grade?: number,
  school?: number,
  date?: { start_date: string; end_date: string }
) => {
  return axios.get(
    `${API}custom/new_admin/overview/teachers?session=${session}&district=${district || -1
    }&block=${block || -1}&grade=${grade || -1}&start_date=${date?.start_date || -1
    }&end_date=${date?.end_date || -1}&school=${school || -1}`
  );
};
export const getStudentOverViewCount = (
  session: number,
  district: number,
  block: number,
  grade: number,
  date: { start_date: string; end_date: string }
) => {
  return axios.get(
    `${API}custom/new_admin/overview/students/count?session=${session}&district=${district || -1
    }&block=${block || -1}&grade=${grade || -1}&start_date=${date?.start_date || -1
    }&end_date=${date?.end_date || -1}`
  );
};
export const getStudentOverViewAppUsage = (
  session: number,
  district?: number,
  block?: number,
  grade?: number,
  school?: number,
  date?: { start_date: string; end_date: string }
) => {
  return axios.get(
    `${API}custom/new_admin/overview/students/appUsage?session=${session}&district=${district || -1
    }&block=${block || -1}&grade=${grade || -1}&start_date=${date?.start_date || -1
    }&end_date=${date?.end_date || -1}&school=${school || -1}`
  );
};
export const getStudentOverViewRemedial = (
  session: number,
  district: number,
  block: number,
  grade: number,
  date: { start_date: string; end_date: string }
) => {
  return axios.get(
    `${API}custom/new_admin/overview/students/assessment/remedial?session=${session}&district=${district || -1
    }&block=${block || -1}&grade=${grade || -1}&start_date=${date?.start_date || -1
    }&end_date=${date?.end_date || -1}`
  );
};
export const getStudentOverViewDiagnostic = (
  session: number,
  district: number,
  block: number,
  grade: number,
  date: { start_date: string; end_date: string }
) => {
  return axios.get(
    `${API}custom/new_admin/overview/students/assessment/diagnostic?session=${session}&district=${district || -1
    }&block=${block || -1}&grade=${grade || -1}&start_date=${date?.start_date || -1
    }&end_date=${date?.end_date || -1}`
  );
};
export const getStudentOverViewHwAttempted = (
  session?: number,
  district?: number,
  block?: number,
  grade?: number,
  school?: number,
  date?: { start_date: string; end_date: string }
) => {
  return axios.get(
    `${API}custom/new_admin/overview/students/assessment/homework/attempted?session=${session}&district=${district || -1
    }&block=${block || -1}&grade=${grade || -1}&start_date=${date?.start_date || -1
    }&end_date=${date?.end_date || -1}&school=${school || -1}`
  );
};
export const getStudentOverViewHwAssigned = (
  session?: number,
  district?: number,
  block?: number,
  grade?: number,
  school?: number,
  date?: { start_date: string; end_date: string }
) => {
  return axios.get(
    `${API}custom/new_admin/overview/students/assessment/homework/assigned?session=${session}&district=${district || -1
    }&block=${block || -1}&grade=${grade || -1}&start_date=${date?.start_date || -1
    }&end_date=${date?.end_date || -1}&school=${school || -1}`
  );
};
export const getStudentOverViewStats = (
  session?: number,
  district?: number,
  block?: number,
  grade?: number,
  date?: { start_date: string; end_date: string }
) => {
  return axios.get(
    `${API}custom/new_admin/overview/students?session=${session}&district=${district || -1
    }&block=${block || -1}&grade=${grade || -1}&start_date=${date?.start_date || -1
    }&end_date=${date?.end_date || -1}`
  );
};

// NEW Map e-Adhigam API 

export const getDistrictMap = (week_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}dashboard_Eadigam?week_no=${week_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/eadigam?week_no=${week_no}&year=${selectedYear}`);
}

export const getBlocksMap = (district: string, week_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}dashboard_Eadigam?district=${district}&week_no=${week_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/eadigam?district=${district}&week_no=${week_no}&year=${selectedYear}`);
}

export const getOverAllStudentStats = (week_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}dashboard?week_no=${week_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard?week_no=${week_no}&year=${selectedYear}`);
}


export const getOverAllTopTotalUsagesStudent = (type: "avgStudentUsage" | string, week_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}dashboard_top_ten?type=${type}&week_no=${week_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/student/top-ten?type=${type}&week_no=${week_no}&year=${selectedYear}&district=-1&block=-1&school=-1`);
}

export const getOverAllDistrictStudentStats = (district: string, week_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}dashboard?district=${district}&week_no=${week_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard?district=${district}&week_no=${week_no}&year=${selectedYear}`);
}

export const getOverAllDistrictTopTotalUsagesStudent = (type: "avgStudentUsage" | string, district: string, week_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}dashboard_top_ten?type=${type}&district=${district}&week_no=${week_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/student/top-ten?type=${type}&district=${district}&week_no=${week_no}&year=${selectedYear}&block=-1&school=-1`);
}

export const getOverAllDistrictAndBlockStudentStats = (district: string, block: string, week_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}dashboard?district=${district}&block=${block}&week_no=${week_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard?district=${district}&block=${block}&week_no=${week_no}&year=${selectedYear}`);
}

export const getOverAllDistrictAndBlockTopTotalUsagesStudent = (type: "avgStudentUsage" | string, district: string, block: string, week_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}dashboard_top_ten?type=${type}&district=${district}&block=${block}&week_no=${week_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/student/top-ten?type=${type}&district=${district}&week_no=${week_no}&block=${block}&school=-1&year=${selectedYear}`);
}

export const getEAdhigamStudent = (week_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}dashboard_Eadigam_students?week_no=${week_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/dashboard-eadigam-students?week_no=${week_no}&year=${selectedYear}`);
}

export const getDistrictEAdhigamStudentCount = (dist: string, week_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}dashboard_Eadigam_students?district=${dist}&week_no=${week_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/dashboard-eadigam-students?district=${dist}&week_no=${week_no}&year=${selectedYear}`);
}

export const getBlockEAdhigamStudentCount = (dist: string, block: string, week_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}dashboard_Eadigam_students?district=${dist}&block=${block}&week_no=${week_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/dashboard-eadigam-students?district=${dist}&block=${block}&week_no=${week_no}&year=${selectedYear}`);
}

// NEW TEACHER API

export const getOverAllTeacherStats = (district: string, block: string, week_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}Teacher_dashboard?district=${district ? district : -1}&block=${block ? block : -1}&school=-1&week_no=${week_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/teacher?week_no=${week_no}&year=${selectedYear}&district=${district ? district : -1}&block=${block ? block : -1}&school=-1`);
}

export const getMonitoringStatsData = (district: string, block: string, week_no: number, selectedYear: number) => {
  let dateStart = `${getDataRangeByWeekNo(week_no).startDate.split("-")[2]}-${getDataRangeByWeekNo(week_no).startDate.split("-")[1]}-${getDataRangeByWeekNo(week_no).startDate.split("-")[0]}`;
  let endDate = `${getDataRangeByWeekNo(week_no).endDate.split("-")[2]}-${getDataRangeByWeekNo(week_no).endDate.split("-")[1]}-${getDataRangeByWeekNo(week_no).endDate.split("-")[0]}`

  return axios.get(`${FLASK_API}custom/dashboard/teacher/timeSpentOnStudentMonitoring?start_date=${dateStart}&end_date=${endDate}&year=${selectedYear}&district=${district}&block=${block}&school_code=-1`)
}

export const getOverAllEAdhigamTeacherStats = (district: string, block: string, week_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}dashboard_Eadigam_teacher?district=${district ? district : -1}&block=${block ? block : -1}&school=-1&week_no=${week_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/dashboard-eadhigam-teachers?week_no=${week_no}&year=${selectedYear}&district=${district ? district : -1}&block=${block ? block : -1}&school=-1`);
}

// Clicked Stats mor info 
export const fetchDataBasedOnLevel = (type: string, week_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}dashboard/student/clickable/data?type=${type}&week_no=${week_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/student-clickable-data?type=${type}&week_no=${week_no}&year=${selectedYear}`);
}
export const fetchDistrictDataBasedOnLevel = (district: string, type: string, week_no: number) => {
  return axios.get(`${FLASK_API}dashboard/student/clickable/data?type=${type}&district=${district}&week_no=${week_no}`)
}
// export const fetchBlockDataBasedOnLevel =( district:string ,block:string, type:string, week_no:number) =>{
//   return axios.get(`${FLASK_API}dashboard/student/clickable/data?type=${type}&district=${district}&block=${block}&week_no=${week_no}`)
// }

export const fetchTeacherDataBasedOnLevel = (type: string, weeK_no: number, selectedYear: number) => {
  // return axios.get(`${FLASK_API}dashboard/teacher/clickable/data?type=${type}&week_no=${weeK_no}`);
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/teacher-clickable-data?type=${type}&week_no=${weeK_no}&year=${selectedYear}`);
}
export const fetchDistrictTeacherDataBasedOnLevel = (district: string, type: string, week_no: number) => {
  return axios.get(`${FLASK_API}dashboard/teacher/clickable/data?type=${type}&district=${district}&week_no=${week_no}`)
}
// Top Ten Teacher api 
export const getTeacherTopTen = (type: string, district: string, block: string, week_no: number, selectedYear: number) => {

  if (type == "timeSpentOnStudentMonitoring") {
    let dateStart = `${getDataRangeByWeekNo(week_no).startDate.split("-")[2]}-${getDataRangeByWeekNo(week_no).startDate.split("-")[1]}-${getDataRangeByWeekNo(week_no).startDate.split("-")[0]}`;
    let endDate = `${getDataRangeByWeekNo(week_no).endDate.split("-")[2]}-${getDataRangeByWeekNo(week_no).endDate.split("-")[1]}-${getDataRangeByWeekNo(week_no).endDate.split("-")[0]}`
    return axios.get(`${FLASK_API}custom/topten/reports/teacher/${type}?start_date=${moment(dateStart).format("YYYY-MM-DD")}&end_date=${endDate}&year=${selectedYear}&district=${district}&block=${block}&school_code=-1`)
  } else {
    // return axios.get(`${FLASK_API}dashboard_teacher/Report/top/ten?type=${type}&district=${district}&block=${block}&week_no=${week_no}&school_code=-1`);
    return axios.get(`${JAVA_DASHBOARD_API}dashboard/teacher/top-ten?type=${type}&week_no=${week_no}&year=${selectedYear}&district=${district}&block=${block}&school=-1`);
  };
}


// Progress Reports API 

export const getOverviewEAdhigam = (district, block, school, week_no, selectedYear: number) => {
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/progressReportPageOne?week_no=${week_no}&year=${selectedYear}&district=${district}&block=${block}&school=${school}`)
}

export const getOverviewTeacherOneHomework = (district, block, school, week_no, selectedYear: number) => {
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/teacher-with-at-least-one-assessment?year=${selectedYear}&district=${district}&block=${block}&school=${school}`)
}

export const getDetailedTeacherUsage = (district, block, school, week_no, selectedYear: number) => {
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/page-two/teacher-student-last-4-weeks-stats?week_no=${week_no}&year=${selectedYear}&district=${district}&block=${block}&school=${school}`)
}

export const getDetailedStudentUsage = (district, block, school, week_no, selectedYear: number) => {
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/page-three/student-weekly-test-usage?week_no=${week_no}&year=${selectedYear}&district=${district}&block=${block}&school=${school}`)
}

export const getOverviewStudentStrength = (district, block, school, week_no, selectedYear: number) => {
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/page-four/student-count-with-at-least-one-diagnostic?week_no=${week_no}&year=${selectedYear}&district=${district}&block=${block}&school=${school}`)
}
export const getDetailedEAdhigamStudent = (district, block, school, week_no, selectedYear: number) => {
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/page-five/last-4-week-adhigam?week_no=${week_no}&year=${selectedYear}&district=${district}&block=${block}&school=${school}`)
}

// TODO: Next three API is only for E-Adhigam Process handle all three api is in third api 
export const getDistrictWiseEAdhigam = (week_no, selectedYear: number) => {
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/adhigam-report-for-every-district?week_no=${week_no}&year=${selectedYear}&district=-1&block=-1&school=-1`)
  // return axios.get(`${FLASK_API}dashboard_Eadigam_progress/report/groupbydistrict?district=-1&block=-1&school=-1&week_no=${-1}`)
  // district?district=-1&block=-1&school=-1&week_no=${(moment().week()-1)}`)
}
export const getBlockWiseEAdhigam = (district, week_no, selectedYear: number) => {
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/adhigam-report-for-every-district?week_no=${week_no}&year=${selectedYear}&district=${district}&block=-1&school=-1`)
  // return axios.get(`${FLASK_API}dashboard_Eadigam_progress/report/groupbyblock?district=${district}&block=-1&school=-1&week_no=${-1}`)
}
export const getSchoolWiseEAdhigam = (district, block, week_no, selectedYear: number) => {
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/adhigam-report-for-schools?week_no=${week_no}&year=${selectedYear}&district=${district}&block=${block}&school=-1`)
}


export const getStudentTeacherStrength = (district, block, school, week_no, selectedYear: number) => {
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/student-teacher-count?week_no=${week_no}&year=${selectedYear}&district=${district}&block=${block}&school=${school}`)
}

export const getTeacherMonitoring = (district, block, school, week_no, selectedYear: number) => {
  return axios.get(`${JAVA_DASHBOARD_API}dashboard/student-monitoring-last-4-weeks?week_no=${week_no}&year=${selectedYear}&district=${district}&block=${block}&school=${school}`)
}